export default __webpack_public_path__ + "static/media/feature-tile-icon-03.69e94e20.svg";